<template>
	<div class="landing">
		<!--<navComponent/>
		<indexComponent /> -->
	</div>
</template>

<script>
  // import navComponent from '@/components/nav.vue'
  // import indexComponent from '@/components/Landing.vue'
  export default {
    name: 'landing',
    data() {
      return {}
    },
    beforeCreate() {
      window.location.href = '/new.html'
    },
    components: {
      // navComponent,
      // indexComponent
    },
    methods: {

    }
  }
</script>

